import { createSlice } from '@reduxjs/toolkit';

const sliceUploadFile = createSlice({
  name: 'uploadFile',
  initialState: {
    fileProgress: '',
    filesObject: {},
    numbHomework: 1,
  },
  reducers: {
    setProgressFile(state, action) {
      state.fileProgress = action.payload;
    },
    setObjectFiles(state, action) {
      state.filesObject = action.payload;
    },
    setNumberHomework(state, action) {
      state.numbHomework = action.payload;
    },
  },
});

export const { setProgressFile, setObjectFiles, setNumberHomework } = sliceUploadFile.actions;

export const getProgressFile = state => state.uploadFile.fileProgress;
export const getObjectFiles = state => state.uploadFile.filesObject;
export const getNumberHomework = state => state.uploadFile.numbHomework;

export default sliceUploadFile.reducer;
